// extracted by mini-css-extract-plugin
module.exports = {"root":"SessionDiagram_root__zfhsA","svg":"SessionDiagram_svg__2Hr76","hide":"SessionDiagram_hide__3sJZE","board":"SessionDiagram_board__1m6zd"};